<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item,index)  in levelList" :key="item.path" v-if="item.meta.title">
        <span v-if="item.redirect==='noredirect'||index==levelList.length-1" class="no-redirect">{{item.meta.title}}</span>
        <router-link @click="acc" v-else :to="item.redirect||item.path">{{item.meta.title}}</router-link>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
export default {
  created() {
    this.getBreadcrumb()
  },
  data() {
    return {
      levelList: null
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
   
  methods: {
    
    getBreadcrumb() {
      
      // let matched = this.$route.matched.filter(item => item.name)
      // const first = matched[0]
      // if (first && first.name !== 'home') {
      //   matched = [{ path: '/home', meta: { title: '首页' }}].concat(matched)
      //   matched=matched
      // }
      // this.levelList = matched
     
      // let aos=this.$router.options.routes,ais={};
      // for(let i in aos){
      //   if(aos[i].path==this.$route.matched[0].path){
      //     for(let j in aos[i].children){
      //       if(aos[i].children[j].name==this.$route.matched[1].name.split('/')[0].toString()){
      //         ais={meta:aos[i].children[j].meta,redirect:this.$route.matched[0].path+'/'+aos[i].children[j].path,path:this.$route.matched[0].path+'/'+aos[i].children[j].path}
      //       }
      //     }
      //   }
      // }
      // this.levelList=[this.$route.matched[0],ais,this.$route.matched[1]]
      this.levelList=this.$route.matched;
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .app-breadcrumb.el-breadcrumb {
    display: inline-block;
    font-size: 14px;
    line-height: 50px;
    margin-left: 32px;
    .no-redirect {
      color: #97a8be;
      cursor: text;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb/index.vue